import { CurCalculation } from "./curCalculation.model";
import { Calculated } from "./calculated.model";
import { Patterns } from "./patterns.model";

export const curCalculation = new CurCalculation();
export const calculated = new Calculated();
export const patterns = new Patterns();
